// Local vector artwork: no emoji, external image requests or runtime SVG markup.
const badgePaths = {
  staff: ['M9 2h6l1 4 4 1 2 5-3 3 1 5-5 2-3-3-4 2-4-4 2-4-3-4 3-4h4l1-3Z', 'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z'],
  partner: ['M8 4 2 10v5l6 6 5-5-3-3-2 2-3-3 3-3 3 3 3-3-6-5Z', 'm16 3-5 5 3 3 2-2 3 3-3 3-3-3-3 3 6 6 6-6v-5l-6-7Z'],
  hypesquad_events: ['m12 1 9 6v11l-9 5-9-5V7l9-6ZM7 7v10h3v-4h4v4h3V7h-3v3h-4V7H7Z'],
  bravery: ['m12 1 9 5-2 11-7 6-7-6L3 6l9-5ZM6 7l6 12 6-12-6 4-6-4Z'],
  brilliance: ['m12 1 10 11-10 11L2 12 12 1Zm0 5-5 6 5 6 5-6-5-6Z'],
  balance: ['m12 1 9 6v11l-9 5-9-5V7l9-6Zm0 5-6 10h12L12 6Zm0 5 2 3h-4l2-3Z'],
  bug_hunter: ['M9 2h6v3l3 2 3-3 2 2-4 4v2h4v3h-4v2l4 3-2 2-4-3-2 3H9l-2-3-4 3-2-2 4-3v-2H1v-3h4v-2L1 6l2-2 3 3 3-2V2Zm2 7v10h2V9h-2Z'],
  early_supporter: ['M2 6h20v15H2V6ZM1 2h22v5H1V2Zm9 7v10h4V9h-4Z', 'M12 6C3 6 5-3 10 1l2 3 2-3c5-4 7 5-2 5Z'],
  early_verified_developer: ['M7 3 0 10v4l7 7 3-3-6-6 6-6-3-3Zm10 0-3 3 6 6-6 6 3 3 7-7v-4l-7-7Z', 'm12 8-2 4 3 2-1 4 4-7-3-1 1-2h-2Z'],
  active_developer: ['M3 2h18v20H3V2Zm4 4-3 6 3 6 2-2-2-4 2-4-2-2Zm10 0-2 2 2 4-2 4 2 2 3-6-3-6Zm-5 0-2 12h2l2-12h-2Z'],
  moderator_alumni: ['m12 1 10 4v7c0 6-10 11-10 11S2 18 2 12V5l10-4Zm-6 6v8h3v-4l3 3 3-3v4h3V7h-3l-3 3-3-3H6Z'],
  nitro: ['m9 3 7-2 7 7-2 7-7 4-9-9 4-7Zm7 2-3 3 3 3 3-3-3-3ZM4 12l8 8-6 3 1-5-5 1 2-7Z'],
  quest: ['M3 2h18v14l-9 7-9-7V2Zm5 4v3H6v3h3v3h3v-3h3V9h3V6H8Z'],
  orbs: ['M12 1a11 11 0 1 0 0 22 11 11 0 0 0 0-22Zm0 4a7 7 0 1 1 0 14 7 7 0 0 1 0-14Zm0 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z'],
  legacy_username: ['M7 2h3L9 7h6l1-5h3l-1 5h5v3h-6l-1 4h5v3h-6l-1 5h-3l1-5H6l-1 5H2l1-5H0v-3h4l1-4H1V7h5l1-5Zm2 8-1 4h5l1-4H9Z'],
  last_meadow: ['M12 2c5-6 10 2 5 6 8-1 8 8 0 9 4 6-4 10-7 3-3 7-11 3-7-3-8-1-8-10 0-9-5-4 0-12 5-6h4Zm0 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z'],
  gifting: ['M2 10h20v12H2V10ZM1 6h22v5H1V6Zm9 0h4v16h-4V6Z', 'M12 7C1 7 3-3 9 1l3 4 3-4c6-4 8 6-3 6Z'],
  account_age: ['M12 1a11 11 0 1 0 0 22 11 11 0 0 0 0-22Zm0 3a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm-1 2h3v6l4 2-2 2-5-3V6Z'],
  streaming: ['M1 3h22v15h-9v3h5v2H5v-2h5v-3H1V3Zm3 3v9h16V6H4Zm5 1 7 4-7 3V7Z'],
  game_time: ['M5 4h14l4 12-3 3-5-4H9l-5 4-3-3L5 4Zm1 3v2H4v2h2v2h2v-2h2V9H8V7H6Zm10 2v3h3V9h-3Z'],
  game_variety: ['M1 1h9v9H1V1Zm13 0h9v9h-9V1ZM1 14h9v9H1v-9Zm17-1 6 6-6 5-6-5 6-6Z']
}
badgePaths.bug_hunter_gold = badgePaths.bug_hunter
const stages = [1, 2, 3, 6, 9, 12, 15, 18, 24]
stages.forEach((month, i) => {
  badgePaths[`booster_${month}`] = [
    'm12 1 8 7v8l-8 7-8-7V8l8-7Zm0 4-4 4v6l4 4 4-4V9l-4-4Z',
    i < 3 ? 'm12 7 3 5-3 5-3-5 3-5Z' : i < 6 ? 'm12 6 2 4 4 2-4 2-2 4-2-4-4-2 4-2 2-4Z' : 'm12 5 2 4 4-1-1 4 3 2-4 1-4 5-4-5-4-1 3-2-1-4 4 1 2-4Z',
    ...(i >= 3 ? ['M1 9h2v7H1V9ZM21 9h2v7h-2V9Z'] : []),
    ...(i >= 6 ? ['M5 1h3v3H5V1ZM16 1h3v3h-3V1Z'] : [])
  ]
})
export default badgePaths
